import api from '../lib/axios';
export async function getPendingContributions() {
    const { data } = await api.get('/api/admin/contributions/pending-count');
    return data;
}
